<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'pricing-01' },
})
</script>

<template>
  <section class="b2-pricing" :class="`variant-${variant}`">
    <div class="b2-section-intro b2-centered">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
      <p class="b2-section-sub">{{ content.sub.value }}</p>
    </div>
    <div class="b2-pricing-grid">
      <div v-for="(item, index) in content.items.value" :key="index" class="b2-pricing-card">
        <div class="b2-pricing-name">{{ item.name }}</div>
        <div class="b2-pricing-price">{{ item.price }}</div>
        <div class="b2-pricing-note" v-if="item.note">{{ item.note }}</div>
      </div>
    </div>
    <p class="b2-pricing-footer">{{ content.footer_note.value }}</p>
  </section>
</template>

<style scoped>
.b2-pricing { padding: 100px 40px; max-width: 1200px; margin: 0 auto; text-align: center; background: #f5f9f4; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin-bottom: 16px; }
.b2-section-sub { font-size: 16px; color: #555; max-width: 560px; line-height: 1.7; margin-bottom: 48px; }
.b2-section-intro.b2-centered { text-align: center; }
.b2-section-intro.b2-centered .b2-section-sub { margin-left: auto; margin-right: auto; }
.b2-pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 24px; margin-top: 48px; }
.b2-pricing-card { padding: 32px 24px; border-radius: 4px; background: #4a8c3f; color: white; box-shadow: 0 8px 32px rgba(74,140,63,.3); transition: transform .2s; }
.b2-pricing-card:hover { transform: translateY(-4px); }
.b2-pricing-name { font-size: 14px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; opacity: .85; margin-bottom: 12px; }
.b2-pricing-price { font-family: 'Playfair Display', serif; font-size: 40px; font-weight: 700; line-height: 1; margin-bottom: 8px; }
.b2-pricing-note { font-size: 13px; opacity: .75; margin-top: 6px; font-style: italic; }
.b2-pricing-footer { margin-top: 48px; font-size: 15px; color: #555; max-width: 600px; margin-left: auto; margin-right: auto; line-height: 1.7; }
.variant-pricing-02 { background: white; }
.variant-pricing-02 .b2-pricing-card { background: white; color: #1a3320; border: 2px solid #b8d9b2; box-shadow: none; }
.variant-pricing-02 .b2-pricing-card:nth-child(2) { border-color: #4a8c3f; transform: translateY(-10px); }
.variant-pricing-03 { text-align: left; background: #f8faf7; }
.variant-pricing-03 .b2-section-intro { max-width: 720px; }
.variant-pricing-03 .b2-section-intro.b2-centered { text-align: left; }
.variant-pricing-03 .b2-section-intro.b2-centered .b2-section-sub { margin-left: 0; }
.variant-pricing-03 .b2-pricing-grid { display: block; border-top: 1px solid #cbdac7; }
.variant-pricing-03 .b2-pricing-card { display: grid; grid-template-columns: 1fr auto; align-items: center; padding: 22px 0; border-radius: 0; border-bottom: 1px solid #cbdac7; background: transparent; color: #1a3320; box-shadow: none; }
.variant-pricing-03 .b2-pricing-card:hover { transform: none; }
.variant-pricing-03 .b2-pricing-name, .variant-pricing-03 .b2-pricing-price { margin: 0; }
.variant-pricing-03 .b2-pricing-note { grid-column: 1 / -1; }
.variant-pricing-03 .b2-pricing-footer { margin-left: 0; }
</style>
